<div class="tagStatusDs__cont tagStatusDs__cont--{{size}} tagStatusDs__cont--{{type}}">
  <div class="tagStatusDs__icon tagStatusDs__icon--{{size}}" *ngIf="icon">
    <app-ds-icon
      [icon]="icon"
      [size]="iconSize"
      [color]="iconColor">
    </app-ds-icon>
  </div>
  <div class="tagStatusDs__status">
    <app-ds-typography
      [tag]="'h3'"
      [size]="fontSize"
      [color]="fontColor"
      [fontFamily]="fontFamily.SemiBold"
      [text]="title">
    </app-ds-typography>
  </div>
</div>